import { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, TrendingUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { cn } from '@/lib/utils';
import { AccountMenu } from '@/components/AccountMenu';

const MAIN_LINKS = [
  { label: 'Daily Pick', to: '/daily-pick' },
  { label: 'AI Coin Reviewer', to: '/coin-reviewer' },
  { label: 'Track Record', to: '/track-record' },
  { label: 'Opportunities', to: '/opportunities' },
  { label: 'Market Analytics', to: '/market-analytics' },
  { label: 'GoToBuddy', to: '/buddy' },
  { label: 'Founder', to: '/founder' },
];

const LEGAL_LINKS = [
  { label: 'Disclaimer', to: '/disclaimer' },
  { label: 'Terms', to: '/terms' },
  { label: 'Privacy', to: '/privacy' },
  { label: 'Contact', to: '/contact' },
];

export const SiteNav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <nav className="sticky top-0 z-50 h-11 md:h-12 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 border-b border-border">
      <div className="container mx-auto px-4 h-full flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 font-bold shrink-0" aria-label="GoToCoins home">
          <TrendingUp className="w-5 h-5 text-primary" />
          <span className="text-base tracking-tight">GoToCoins</span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {MAIN_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                cn(
                  'px-2.5 py-1.5 rounded-md text-sm transition-colors',
                  isActive
                    ? 'text-primary bg-primary/10 font-semibold'
                    : 'text-muted-foreground hover:text-foreground hover:bg-secondary/60'
                )
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-1">
          <AccountMenu />

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon" aria-label="Open menu" className="h-8 w-8">
              <Menu className="w-5 h-5" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-72 p-0">
            <div className="flex flex-col gap-1 p-4 pt-10">
              {MAIN_LINKS.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setOpen(false)}
                  className={cn(
                    'px-3 py-2.5 rounded-md text-sm',
                    pathname === link.to
                      ? 'text-primary bg-primary/10 font-semibold'
                      : 'text-foreground hover:bg-secondary/60'
                  )}
                >
                  {link.label}
                </Link>
              ))}
              <div className="my-3 border-t border-border" />
              {LEGAL_LINKS.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setOpen(false)}
                  className={cn(
                    'px-3 py-2 rounded-md text-xs',
                    pathname === link.to
                      ? 'text-primary font-semibold'
                      : 'text-muted-foreground hover:text-foreground'
                  )}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </SheetContent>
        </Sheet>
        </div>
      </div>
    </nav>
  );
};
